<template>
  <div class="holesDeliveriesemployee">
      <b-container >
        <b-tabs  :justified="['xs', 'sm', 'md'].includes(windowsize.breakpoint)"> 
            <b-tab active>
                <template #title>
                    Deliveries
                </template>
                
                <deliveries 
                    ref="deliveries"
                    @update="newupdate"/>
            </b-tab>

            <b-tab>
                <template #title>
                    History
                </template>

                <order-history @getdeliverylist="$refs.deliveries.getallassignedorders()" ref="history" />
            </b-tab>
        </b-tabs>
      </b-container>
  </div>
</template>

<script>
// components
import deliveryList from '@/components/employee/deliveryList.vue';
import orderHistory from '@/components/employee/orderHistoryList.vue'

export default {
    components : {
        'deliveries'   : deliveryList,
        'order-history': orderHistory
    },
    computed : {
        /**
         * Window size
         */
        windowsize() {
            return this.$store.state.windowsize
        }
    },
    methods : {
        /**
         * Listen for new updates
         */
        newupdate() {
            // update history 
            this.$refs.history.getemployeeshistory();
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/partials/_mixins.scss';
@import '@/scss/partials/_colors.scss';

.holesDeliveriesemployee {

    @include screen-min(lg) {
        background-color: $lightgrey;
        min-height      : 100vh;
        padding-top     : 30px;
    }

     .tabs {
        .nav-tabs {
            @include screen-min(lg) {
                border-bottom: none;
                margin-bottom: 30px;
            }
        }

        .nav-item {
            .nav-link {
                border-color : transparent;
                border       : none;
                border-bottom: 2.5px solid transparent;
                font-weight  : 700;
                outline      : none !important;

                @include screen-min(lg) {
                    border-bottom: 2.5px solid $lightgrey3;
                    padding-right: 30px;

                    &:first-child {
                        padding-left: 0;
                    }
                }

                &:hover {
                    color  : $primaryColor;
                    outline: none !important;
                }

                &:focus {
                    outline: none !important;
                }

                &.active {
                    border-bottom: 2.5px solid $primaryColor;
                    font-weight: 800;
                    color: $black;
                    outline      : none !important;

                    @include screen-min(lg) {
                        background-color: transparent;
                    }
                }
            }
        }
    }
}


</style>